<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th translate>ITEM</th>
        <th translate>QUANTITY</th>
        <th translate>GROSS_PRICE</th>
        <th translate>DISCOUNT_PERCENT</th>
        <th translate>PRICE</th>
        <th translate>TOTAL</th>
        <th *ngIf="isCapstone" translate width="200px">DELIVERY</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of mappedData; trackBy: trackByFn">
        <td class="text-nowrap">
          {{ row.productId }}
          <span *ngIf="row.productId !== row.name" class="text-nowrap">
            <br />
            {{ row.name }}
          </span>
        </td>
        <td>
          <div *ngIf="isCapstone; else otherProject">
            <lib-buy-btn [id]="row.productId"> </lib-buy-btn>
          </div>

          <ng-template #otherProject>
            <lib-buy-btn
              [id]="row.productId"
              [minimumOrderQuantity]="row.cartRow.extra.ar ? row.cartRow.extra.ar.artfsgforp : null"
              [stepAmount]="row.cartRow.extra.ar ? row.cartRow.extra.ar.artfsgforp : null"
            >
            </lib-buy-btn>
          </ng-template>
        </td>
        <td>
          <input
            type="number"
            class="form-control"
            [value]="row.overridePrice"
            [placeholder]="row.originalPrice | number: '1.0-2'"
            (blur)="updateOverridePrice(row, $event.target.value)"
          />
        </td>
        <td>
          <input
            type="number"
            class="form-control discount-control"
            [value]="row.discountPercent"
            (blur)="updateDiscountPercentage(row, $event.target.value)"
            placeholder="{{ row.cartRowPriceElement.backendPriceLevel.extra.CustomerDiscount | number: '1.0-2' }}"
          />
        </td>
        <td>
          {{
            row.cartRowPriceElement.cartRowUnitPriceInclRowDiscount.value
              | gungCurrency: row.cartRowPriceElement.cartRowUnitPriceInclRowDiscount.currencyCode
          }}
          (-{{ row.cartRowPriceElement.cartRowDiscountPercent | number: '1.0-2' }}%)
        </td>
        <td>
          {{
            row.cartRowPriceElement.cartRowTotalPriceInclRowDiscount.value
              | gungCurrency: row.cartRowPriceElement.cartRowTotalPriceInclRowDiscount.currencyCode
          }}
          <i 
            class="fa-light fa-circle-info cursor-pointer"
            placement="top"
            ngbTooltip="{{ 'MARGIN' | translate}}: {{ (row.cartRowPriceElement.cartRowUnitPriceInclRowDiscount.value - row.product.extra.ar.artkalkpris) | gungCurrency:'SEK' }} ({{ ((row.cartRowPriceElement.cartRowUnitPriceInclRowDiscount.value) ? (100 - ((row.product.extra.ar.artkalkpris * 100)/row.cartRowPriceElement.cartRowUnitPriceInclRowDiscount.value)) : -100) | number:'0.0-2' }}%)">
          </i>
        </td>
        <td *ngIf="isCapstone">
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="dp"
              ngbDatepicker
              #d="ngbDatepicker"
              readonly
              container="body"
              [value]="row.deliveryDate ? row.deliveryDate : formatNgbDate(row.minDate)"
              [minDate]="row.minDate"
              (dateSelect)="updateDeliveryDate(row, $event)"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button">
                <i class="fas fa-calendar"></i>
              </button>
            </div>
          </div>
        </td>
        <td>
          <button class="btn" type="button" (click)="removeRow(row)">
            <i class="fas fa-times"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
